import { Box } from '@mui/material'
import { C1Icon } from 'components/core/icons/C1Icon'
import { RecommendationDenyTooltip, RecommendationReviewTooltip } from 'components/core/insights'
import { TaskValue } from 'lib/actions/task'
import { AlertCircle, ThumbsDown } from 'lucide-react'
import { InsightRecommendation } from 'pbts/c1/api/task/v1/insights'
import { FC } from 'react'

export type TaskRecommendationProps = {
    task: TaskValue
}

export const TaskRecommendation: FC<TaskRecommendationProps> = ({ task }) => {
    const recommendation = task.recommendation

    if (recommendation === InsightRecommendation.UNSPECIFIED) {
        return <></>
    }

    if (recommendation === InsightRecommendation.DENY) {
        return (
            <RecommendationDenyTooltip task={task}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <C1Icon icon={ThumbsDown} size="sm" sx={{ color: 'error.main' }} />
                </Box>
            </RecommendationDenyTooltip>
        )
    }

    if (recommendation === InsightRecommendation.REVIEW) {
        return (
            <RecommendationReviewTooltip task={task}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <C1Icon icon={AlertCircle} size="sm" sx={{ color: 'warning.main' }} />
                </Box>
            </RecommendationReviewTooltip>
        )
    }

    return <></>
}
